/** A copy of the set with the value removed if present, added otherwise. */
export const toggleInSet = <T>(set: Set<T>, value: T): Set<T> => {
    const next = new Set(set);
    if (next.has(value)) {
        next.delete(value);
    } else {
        next.add(value);
    }
    return next;
};
